<template>
  <div class="animated fadeIn">
    <a @click="openPage('/memberData/detail?id=' + id_lead_member + '&id_lead=' + id_lead)" class="link-back"><i
        class="fas fa-arrow-circle-left mr-5 mb-15"></i>Back</a>
    <div class="box">
      <div class="p-20">
        <div class="mb-20">
          <div class="row">
            <div class="col-sm-6">
              <div class="font-bold mb-10">Member Diary ({{ parseDate(member_diary_date) }})</div>
            </div>
            <div class="col-sm-6 text-right">
              <b-button size="sm"
                @click="openPage(`/memberData/addSecondMemberDiary?id=${id_lead_member}&id_lead=${id_lead}&date=${member_diary_date}&pt_id=${pt_id}`)"
                class="btn-table primary mb-5">
                <i class="far fa-edit"></i> Add
              </b-button>
            </div>
          </div>
          <div class="box-mini">
            <div class="p-15">
              <div class="header">
                <table>
                  <tr>
                    <td>Personal Trainer</td>
                    <td>{{ itemMemberDiary[0] ? itemMemberDiary[0].personal_training.name : '-' }}</td>
                  </tr>
                  <tr>
                    <td>Number Of Session</td>
                    <td>{{ totalNumberOfMovement }}</td>
                  </tr>
                  <tr>
                    <td>How Many Movement</td>
                    <td>{{ totalNumberOfSession }}</td>
                  </tr>
                </table>
              </div>
              <hr>
              <template v-for="item in createNewListData">
                <div :key="item.id">
                  <h5>{{ item.category ? item.category.name : '' }}</h5>
                  <div style="overflow-x:auto;">
                    <table>
                      <tr>
                        <th></th>
                        <!-- <th style="background-color: orange;">Diary Subcategory</th> -->
                        <th style="background-color: orange;">Exercise</th>
                        <th style="background-color: orange;">Sets</th>
                        <th style="background-color: orange;">Reps</th>
                        <th style="background-color: orange;">Weight/ Intensity</th>
                        <th style="background-color: orange;">Notes</th>
                        <th style="background-color: orange;">Action</th>
                      </tr>
                      <tr v-for="(sub, index) in item.data" :key="index + '3'">
                        <td style="background-color: orange;">Training Movement {{ sub.no }}</td>
                        <!-- <td><p>{{sub.member_pt_diary_activity.member_pt_diary_subcategory == null ? '' : sub.member_pt_diary_activity.member_pt_diary_subcategory.name}}</p></td> -->
                        <td>
                          <p>{{ sub.member_pt_diary_activity.excercise_name }}</p>
                        </td>
                        <td>
                          <p>{{ sub.sets }}</p>
                        </td>
                        <td>
                          <p>{{ sub.reps }}</p>
                        </td>
                        <td>
                          <p>{{ sub.weight }}</p>
                        </td>
                        <td>
                          <p>{{ sub.notes === null ? '-' : sub.notes }}</p>
                        </td>
                        <td>
                          <b-button size="sm"
                            @click="openPage('/memberData/editMemberDiary?id=' + id_lead_member + '&id_lead=' + id_lead + '&id_item=' + sub.id + '&date=' + member_diary_date)"
                            class="btn-table green mb-5">
                            <i class="far fa-edit"></i> Edit
                          </b-button>
                          <br>
                          <b-button size="sm" @click="deleteMemberDiaryItem(sub)" class="btn-table  danger mb-5">
                            <i class="fas fa-times"></i> Delete
                          </b-button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </template>
              <!-- <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="itemMemberDiary" :fields="fieldDiary">
                <template v-slot:cell(action)="data">
                  <b-button size="sm" @click="openPage('/memberData/editMemberDiary?id=' + id_lead_member + '&id_lead=' + id_lead + '&id_item=' + data.item.id)" class="btn-table green mb-5">
                    <i class="far fa-eye"></i> Detail
                  </b-button>
                </template>
              </b-table>
              <app-pagination class="pagination-custom mt-20"
                :current-page="currentPage"
                :total-pages="totalPage"
                @page-changed="pageOneChanged"
                prev-text="Prev" next-text="Next"/> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

h5 {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

td {
  height: 50px;
  width: 300px;

  p {
    // padding-left: 10px;
  }
}
</style>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import { ModelSelect } from 'vue-search-select'
import Pagination from '@/views/component/pagination'

export default {
  name: 'listMemberDiary',
  components: {
    'app-pagination': Pagination,
    ModelSelect
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      newMemberDiaryDataParent: [],
      newMemberDiaryData: [],
      createNewListData: [],
      totalNumberOfSession: 0,
      totalNumberOfMovement: 0,
      member_diary_date: '',
      dataPT: [],
      id_lead_member: '',
      id_lead: '',
      pt_id: null,
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      optionsMember: [
        { value: null, text: 'Please select' }
      ],
      fieldDiary: [
        {
          key: 'member_pt_diary_activity.excercise_name',
          label: 'Excercise Name',
          sortable: true
        },
        {
          key: 'time',
          label: 'Time',
          sortable: true
        },
        {
          key: 'rest_time',
          label: 'Rest Time',
          sortable: true
        },
        {
          key: 'member_pt_diary_activity.member_pt_diary_subcategory.member_pt_diary_category.name',
          label: 'Category',
          sortable: true
        },
        {
          key: 'member_pt_diary_activity.member_pt_diary_subcategory.name',
          label: 'Sub Category',
          sortable: true
        },
        {
          key: 'schedule_date',
          label: 'Date',
          formatter: (value, key, item) => {
            return moment(item.schedule_date).format('DD MMMM YYYY')
          },
          sortable: true
        },
        {
          key: 'action',
          label: 'Action'
        }
      ],
      itemMemberDiary: [],
    }
  },
  methods: {
    async deleteMemberDiaryItem(data) {
      let isConfirm = await this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
        showLoaderOnConfirm: false
      })
      if (isConfirm.value) {

        try {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          await axios.delete('crm/v1/member_pt_diary/'.concat(data.id))
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          this.fetchData()
        } catch (error) {
          console.log('error', error)
        }
      } else {
        this.$swal('Cancelled', 'Cancelled', 'info')
      }
    },
    openPage(event) {
      this.$router.push(event)
    },
    getRowCount(items) {
      return items.length
    },
    parseDate(value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    fetchData() {
      // turn off autocomplete
      if (document.getElementsByTagName) {
        var inputElements = document.getElementsByTagName("member_id")
        for (var i = 0; inputElements[i]; i++) {
          if (inputElements[i].className && (inputElements[i].className.indexOf("disableAutoComplete") != -1)) {
            inputElements[i].setAttribute("autocomplete", "off")
          }
        }
      }
      axios.get('fitness/v1/member/data_entry').then(response => {
        var dataMember = response.data.data.rows
        for (var i = 0; i < dataMember.length; i++) {
          let memberBranchId
          if (!dataMember[i].branch_id) {
            memberBranchId = '(FT-' + dataMember[i].id + ') ' + dataMember[i].first_name + ' ' + dataMember[i].last_name
          } else {
            memberBranchId = '(' + dataMember[i].branch.codename + '-' + dataMember[i].id + ') ' + dataMember[i].first_name + ' ' + dataMember[i].last_name
          }
          // var dataComplete = Object.assign({}, {value: null, text: 'Please select' }, {value: dataMember[i].id, text: dataMember[i].first_name + ' ' + dataMember[i].last_name})
          var dataComplete = Object.assign({}, { value: null, text: 'Please select' }, { value: dataMember[i].id, text: memberBranchId })
          this.optionsMember.push(dataComplete)
        }
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/personal_training').then(response => {
        this.dataPT = response.data.data.rows
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/member_pt_diary_category').then(response => {
        this.listCategory = response.data.data
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/member_pt_diary?member=' + this.$route.query.id + '&scheduledate=' + this.$route.query.date + '&page=' + this.currentPage + '&limit=' + this.paginationLimit).then(response => {
        this.itemMemberDiary = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })

      // new get member diary data
      axios.get(`crm/v1/member_pt_diary/?member=${this.$route.query.id}&scheduledate=${this.$route.query.date}`).then(response => {
        // console.log(response)
        this.createNewListData = []
        this.newMemberDiaryDataParent = []
        this.newMemberDiaryData = []

        const itemMemberDiary = response.data.data.rows
        if (itemMemberDiary.length > 0) {
          this.pt_id = response.data.data.rows[0] ? response.data.data.rows[0].personal_training.id : ''
        }
        this.newMemberDiaryDataParent = itemMemberDiary
        if (itemMemberDiary.length == 0) {
          this.openPage('/memberData/detail?id=' + this.id_lead_member + '&id_lead=' + this.id_lead)
        }

        for (let i = 0; i < itemMemberDiary.length; i++) {
          this.newMemberDiaryData.push({
            // id: itemMemberDiary[i].member_pt_diary_activity.excercise_name
            id: itemMemberDiary[i].member_pt_diary_category ? itemMemberDiary[i].member_pt_diary_category.name : '',
            main_id: itemMemberDiary[i].member_pt_diary_category ? itemMemberDiary[i].member_pt_diary_category.id : ''
          })
        }
        this.checkDuplicateData()
        // console.log(this.newMemberDiaryData)
      }).catch(error => {
        console.log('error', error)
      })
    },
    checkDuplicateData() {
      const uniqueItem = Array.from(new Set(this.newMemberDiaryData.map(a => a.id)))
        .map(id => {
          return this.newMemberDiaryData.find(a => a.id === id)
        })
      var getArrayValue = uniqueItem.find((m) => m.id === "Cooling down / Strecthing")
      var fromIndex = uniqueItem.indexOf(getArrayValue)
      const elements = uniqueItem.splice(fromIndex, 1)[0];
      var toIndex = uniqueItem.length
      uniqueItem.splice(toIndex, 0, elements)

      this.newMemberDiaryData = uniqueItem

      this.newMemberDiaryData.forEach((el, index) => {
        if (el.id.toLowerCase() === 'preparation' && el.main_id === 1) {
          this.newMemberDiaryData.splice(index, 1) // remove array
          this.newMemberDiaryData.unshift({
            id: 'Preparation',
            main_id: 1
          })
        }
      });

      this.newMemberDiaryData.forEach((el, index) => {
        if (el.id.toLowerCase() === 'cooling down / streching' && el.main_id === 148) {
          this.newMemberDiaryData.splice(index, 1) // remove array
          this.newMemberDiaryData.push({
            id: 'Cooling down / Streching',
            main_id: 28
          })
        }
      });

      this.newMemberDiaryData.forEach((el, index) => {
        if (el.id.toLowerCase() === 'loaded movement' && el.main_id === 147) {
          this.newMemberDiaryData.splice(index, 1) // remove array
          this.newMemberDiaryData.push({
            id: 'Loaded Movement',
            main_id: 291
          })
        }
      });

      let no = 0
      for (let i = 0; i < this.newMemberDiaryData.length; i++) {
        let newData = this.newMemberDiaryDataParent.filter((model) => model.member_pt_diary_category.name == this.newMemberDiaryData[i].id)
          for (let t = 0; t < newData.length; t++) {
           
            if (newData[t] !== undefined) {
              Object.assign(newData[t], { no: (t+1) })
              this.totalNumberOfSession += 1
            }
            no += 1
            
          }
          this.totalNumberOfMovement += 1
          this.createNewListData.push({
            id: this.newMemberDiaryData[i].id,
            category: newData.length > 0 ? newData[0].member_pt_diary_category === null || newData[0].member_pt_diary_category === undefined ? '' : newData[0].member_pt_diary_category : '',
            data: newData
          })
      }

      this.totalNumberOfSession = this.totalNumberOfSession / this.newMemberDiaryData.length
      let oldData = this.createNewListData
      this.createNewListData = [...new Map(oldData.map((m) => [m.category, m])).values()]
    }
  },
  created() {
    this.fetchData()
    this.id_lead_member = this.$route.query.id
    this.id_lead = this.$route.query.id_lead
    this.member_diary_date = this.$route.query.date
  }
}
</script>

<style></style>
